// src/redux/slices/categorySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [], // Array to store categories
  loading: false,
  error: null,
};

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategory: (state, action) => {
      console.log('Setting categories in categorySlice:', action.payload);
      state.categories = action.payload.data;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearCategories: (state) => {
      state.categories = [];
      state.error = null;
    },
  },
});

export const { setCategory, setLoading, setError, clearCategories } = categorySlice.actions;
export default categorySlice.reducer;